// 注册微信分享链接
import log from '../../utils/log';
import loadScript from '../../utils/loadScript';
const wx_update_sign = async (url) => {
  return await fetch(
    `${import.meta.env.VITE_BASEAPI}/user/h5_wx_sign_url_v2?url=${url}`
  )
    .then((res) => {
      return res.json();
    })
    .then((ret) => {
      if (!ret.error) {
        return ret.sign;
      } else {
        console.error(ret.errorMsg);
        log({
          type: 'fetch',
          error: ret.error,
          url: 'user/h5_wx_sign_url_v2',
        });
      }
    })
    .catch((e) => {
      log({
        type: 'fetch',
        error: e,
        url: 'user/h5_wx_sign_url_v2',
      });
    });
};
const wx_config = async (props = {}) => {
  // 微信分享的配置
  const { title, desc, imgUrl, url } = props;
  const wx_conf = await wx_update_sign(location.href.split('#')[0]);
  console.log('wx_conf', wx_conf);

  wx.config({
    debug: false,
    appId: 'wx85f583832dbd07e9',
    // 最新版本
    timestamp: wx_conf.timestamp,
    nonceStr: wx_conf.nonceStr,
    signature: wx_conf.signature,
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
  });
  wx.ready(function () {
    //需在用户可能点击分享按钮前就先调用
    wx.updateAppMessageShareData({
      link: url,
      title: title ? title : '默认标题！',
      desc: desc ? desc : '默认描述！',
      imgUrl: imgUrl
        ? imgUrl
        : 'https://webinput.nie.netease.com/img/tx3/logo3.png',
      success: function () {
        console.log('wx updateAppMessage');
      },
      fail: function (res) {
        wx.onMenuShareAppMessage({
          link: url ? url : location.href.split('#')[0],
          title: title ? title : '默认标题！',
          desc: desc ? desc : '默认描述！',
          imgUrl: imgUrl ? imgUrl : 'https://webinput.nie.netease.com/img/tx3/logo3.png',
        })
      },
    });

    wx.updateTimelineShareData({
      link: url,
      title: title ? title : '默认标题！',
      imgUrl: imgUrl
        ? imgUrl
        : 'https://webinput.nie.netease.com/img/tx3/logo3.png',
      success: function () {
        console.log('wx updateTimelin');
      },
    });
    wx.miniProgram.postMessage({
      data: {
        title: title || '默认标题',
        path: `/pages/needWebview/index?src=${encodeURIComponent(url)}`,
        type: 'setShareConfig',
        imageUrl: imgUrl,
      },
    });
  });

  wx.error(function (res) {
    console.log('wx config error 失败', res);
    log({
      type: 'wx',
      message: '签名失败',
      res: res,
    });
  });
};

export const reg_wx_share = async ({ title, desc, imgUrl, url }) => {
  console.log('title', title);
  console.log('desc', desc);
  console.log('url', url);
  console.log('img', imgUrl);
  if (!window.isWx) {
    loadScript(
      'https://g20.gsf.netease.com/2025041502npm/tx_npm/202504117/wx.js',
      () => {
        window.isWx = true;
        setTimeout(() => {
          wx_config({ title, desc, imgUrl, url });
          // 首次注册，加个2秒的延迟
        }, 2000);
      }
    );
  } else {
    wx_config({ title, desc, imgUrl, url });
  }
};
